import {Injectable} from '@angular/core';

import {TakeUntilComponentDestroy} from '@q9elements/ui-kit/common';
import {ContextMenuItem} from '@q9elements/ui-kit/components';
import {ContextMenuItemsService} from './context-menu-items.service';

@Injectable()
export class ContextMenuViewService extends TakeUntilComponentDestroy {
  constructor(private contextMenuItemsService: ContextMenuItemsService) {
    super();
  }

  public getTreeGridBaseItems(idParam = 'id'): ContextMenuItem[] {
    if (this.contextMenuItemsService.isSelectedNodeIdEqualToRefModelId) {
      return [];
    }

    const changesItems = this.contextMenuItemsService.getChangesContextMenuItems(idParam, true);
    const documentationItems =
      this.contextMenuItemsService.getDocumentationContextMenuItems(idParam);
    const dependencySubItems = this.contextMenuItemsService.getDependencyContextMenuItems(idParam);

    return [...changesItems, ...documentationItems, ...dependencySubItems];
  }

  public getTreeGridContextMenuItems(idParam = 'id'): ContextMenuItem[] {
    const tagsChangeItems = this.contextMenuItemsService.isNodeLevel
      ? this.contextMenuItemsService.getTagsChangeContextMenuItems(idParam)
      : [];
    const actionItems =
      this.contextMenuItemsService.isExternalRefModel && this.contextMenuItemsService.isNodeLevel
        ? this.contextMenuItemsService.getActionsForContextMenuItems(idParam)
        : [];

    const treeGridItems = [
      ...actionItems,
      ...this.getTreeGridBaseItems(),
      ...this.contextMenuItemsService.getCodeSearchContextMenuItems(),
      ...tagsChangeItems,
      ...this.contextMenuItemsService.getCreateNewNodeContextMenuItems(),
      ...this.contextMenuItemsService.getProposedNodeItem(),
      ...this.contextMenuItemsService.getMakeNodeRootContextMenuItem()
    ];

    return treeGridItems.filter(item => item.hasShow());
  }

  public getTreeGridContextMenuItemsForGroupingNodes(): ContextMenuItem[] {
    const menuItems = [
      ...this.contextMenuItemsService.getCodeSearchContextMenuItems(),
      ...this.contextMenuItemsService.getMakeNodeRootContextMenuItem(),
      ...this.contextMenuItemsService.getProposedNodeItem()
    ];

    return menuItems.filter(item => item.hasShow());
  }

  public getBaseContextMenuItems(idParam = '_id', isCodeSearch = false): ContextMenuItem[] {
    const items = [
      ...this.contextMenuItemsService.getActionsForContextMenuItems(idParam, false, isCodeSearch),
      ...this.contextMenuItemsService.getChangesContextMenuItems(idParam, false, isCodeSearch),
      ...this.contextMenuItemsService.getDocumentationContextMenuItems(idParam, isCodeSearch),
      ...this.contextMenuItemsService.getDependencyContextMenuItems(idParam, false, isCodeSearch),
      ...this.contextMenuItemsService.getCodeSearchContextMenuItems(idParam, isCodeSearch),
      ...this.contextMenuItemsService.getTagsChangeContextMenuItems(idParam, false, isCodeSearch),
      ...this.contextMenuItemsService.getShowComponentInMetadataDictionary(idParam, isCodeSearch)
    ];

    return items.filter(item => item.hasShow());
  }

  public getContextMenuForMultipleNodes(idParam = '_id', isCodeSearch = false): ContextMenuItem[] {
    const items = [
      ...this.contextMenuItemsService.getActionsForContextMenuItems(idParam, false, isCodeSearch),
      ...this.contextMenuItemsService.getChangesContextMenuItems(idParam, false, isCodeSearch),
      ...this.contextMenuItemsService.getTagsChangeContextMenuItems(idParam, false, isCodeSearch),
      ...this.contextMenuItemsService.getOpenDependencyGridMenuItem(idParam, isCodeSearch)
    ];

    return items.filter(item => item.hasShow());
  }

  public getContextMenuItemsForCustomView(
    idParam = '_id',
    isCodeSearch = false
  ): ContextMenuItem[] {
    if (this.contextMenuItemsService.selectedItemsCount === 1) {
      return this.getBaseContextMenuItems(idParam, isCodeSearch);
    }

    return this.getContextMenuForMultipleNodes(idParam, isCodeSearch);
  }

  public getDependencyGridMenuItems(idParam: string = 'dependentId'): ContextMenuItem[] {
    const dependencyMenuItems = [
      ...this.contextMenuItemsService.getActionsForContextMenuItems(idParam, true),
      ...this.contextMenuItemsService.getChangesContextMenuItems(idParam),
      ...this.contextMenuItemsService.getTagsChangeContextMenuItems(idParam, true),
      ...(this.contextMenuItemsService.selectedItemsCount === 1
        ? [
            ...this.contextMenuItemsService.getDependencyContextMenuItems(idParam, true),
            ...this.contextMenuItemsService.getCodeSearchContextMenuItems(idParam),
            ...this.contextMenuItemsService.getShowComponentInMetadataDictionary(idParam)
          ]
        : [])
    ];

    return dependencyMenuItems.filter(item => item.hasShow());
  }
}
